import React, { Component } from 'react'
import $ from 'jquery'
import * as Common from '../CommonControlls/CommonJs'
import MainLayout from '../CommonControlls/MainLayout'
import Topmenu from '../CommonControlls/Topmenubar'
import { connect } from 'react-redux'
import Table from '../CommonControlls/TableRendrer'
import { Link } from 'react-router-dom'
import DropDown from '../CommonControlls/DropdownRendrer'
import UserLogo_Tablelist from '../../images/UserLogo_Tablelist.png'
import {
  SelectAllRoles,
  SelectAllDistricts,
  SelectAllProvince,
  SelectAllTehsils,
} from '../OfflineDb/IndexDbTranscSP'
import AlertModal from '../CommonControlls/AlertModal'
import { SyncConfig } from '../OfflineDb/ConfigDataSync'
import jsPDF from 'jspdf'

const mapStateToProps = (store) => {
  return store
}

const mapDispatchToProps = (dispatch) => {
  return {
    ShowAlert: (Settings) => {
      dispatch({ type: 'UpdateAlert', payload: Settings })
    },
    ShowLoader: (Isloading) => {
      dispatch({ type: 'UpdateLoader', payload: Isloading })
    },
  }
}

class Users_Requests extends Component {
  constructor(props) {
    super(props)
    this.state = {
      // Table
      data: [],
      page: 1,
      sizePerPage: 15,
      TotalRecord: 0,
      loading: false,
      exportLoading: false,

      sortField: 'id',
      idsortOrder: 'desc',
      provinceNamesortOrder: '',
      districtNamesortOrder: '',
      tehsilNamesortOrder: '',
      roleNamesortOrder: '',
      creationDateTimesortOrder: '',

      //Roles
      RolesLoader: false,
      Roleslist: [],
      RoleId: 0,

      alertModalData: {
        title: '',
        message: '',
        First_Callback: () => {},
        Second_Callback: () => {},
        type: 1,
      },

      ProvinceLoader: false,
      Provincelist: [],
      ProvinceId: 0,

      DistrictLoader: false,
      Districtlist: [],
      FilteredDistrictlist: [],
      DistrictId: 0,

      TehsilLoader: false,
      Tehsillist: [],
      FilteredTehsillist: [],
      TehsilId: 0,

      permissions: [],
    }
  }

  HandleAutoSuggestValChange = (fieldId, value) => {
    this.setState({ [fieldId]: value }, () => {
      if (fieldId == 'ProvinceId') {
        var TempArr = this.state.Districtlist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.provinceId == value
        })
        this.setState({
          FilteredDistrictlist: filteredArr,
        })
      }
      if (fieldId == 'DistrictId') {
        var TempArr = this.state.Tehsillist
        var filteredArr = TempArr.filter(function (obj) {
          return obj.districtId == value
        })
        this.setState({
          FilteredTehsillist: filteredArr,
        })
      }
    })
  }

  render() {
    const CellMenu = (cell, row) => {
      return (
        <div>
          <button
            onClick={() => this.ApproveUser(row.id, row.role)}
            data-toggle="tooltip"
            title="Approve"
            class="btn TableRow_btn"
          >
            <i
              class="fa fa-pencil-square-o text-primary"
              aria-hidden="true"
            ></i>
          </button>
          <button
            onClick={() => this.onReject(row.id, row.role)}
            data-toggle="tooltip"
            title="Reject"
            class="btn TableRow_btn"
          >
            <i class="fa fa-trash-o text-danger" aria-hidden="true"></i>
          </button>
        </div>
      )
    }

    // function avatarformatter(cell, row) {
    //     return (
    //         <span style={{display:"flex"}}>
    //             <span style={{flex:"1",maxWidth:"45px",position:"relative",bottom:"-5px"}}>
    //                 <img class="user-avatar rounded-circle" style={{border:"1px solid #ced4da"}} height="37px" width="37px" src={row.imageURL == ""||row.imageURL == null ? UserLogo_Tablelist : row.imageURL} />
    //             </span>
    //             <span>
    //                 {row.name}<br/>
    //                 <span>{row.contact}</span>
    //             </span>

    //         </span>
    //     );
    // }

    const UserTypeformatter = (cell, row) => {
      return <div className="UserType_Span">{cell}</div>
    }

    const columns = [
      {
        dataField: 'provinceName',
        text: 'Province',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
      },
      {
        dataField: 'districtName',
        text: 'District',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
      },
      {
        dataField: 'tehsilName',
        text: 'Tehsil',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
      },
      {
        dataField: 'name',
        text: 'User Name',
        // formatter: (cell, row)=>{ return avatarformatter(cell, row)},
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
      },
      {
        dataField: 'cnic',
        text: 'CNIC #',
        sort: true,
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
      },
      // {
      //     dataField: 'contact',
      //     text: 'Phone',
      //     sort: true,
      //     csvFormatter:contact => ( contact==null?"":contact ),
      // },
      {
        dataField: 'roleName',
        text: 'User Type',
        formatter: (cell, row) => {
          return UserTypeformatter(cell, row)
        },
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
        sort: true,
      },
      // {
      //     dataField: 'email',
      //     text: 'Email',
      //     headerStyle: (colum, colIndex) => {return { width: '220px' }},
      //     sort: true,
      // },
      {
        dataField: 'creationDateTime',
        text: 'Requested On',
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
        formatter: (cell, row) => {
          return Common.ConvertToLocalDateTime(cell)
        },
        csvFormatter: (creationDateTime) =>
          Common.ConvertToLocalDateTime(creationDateTime),
        sort: true,
      },
      {
        dataField: '',
        text: 'Actions',
        headerStyle: (colum, colIndex) => {
          return { fontSize: '13px' }
        },
        formatter: (cell, row) => {
          return CellMenu(cell, row)
        },
        csvExport: false,
      },
    ]

    return (
      <div>
        <MainLayout />
        <AlertModal {...this.state.alertModalData} />
        <div id="right-panel" class="right-panel">
          <Topmenu PageTitle="Users & Requests" isShowAddBtn={false} />
          <div class="content">
            {/* <div class="PageHeader_Container">
                <h2 class="Pageheading">User Requests</h2>
            </div> */}

            <div
              class="card"
              style={{
                marginBottom: '20px',
                background: 'none',
                boxShadow: 'none',
              }}
            >
              <div class="card-body row" style={{ padding: '0px' }}>
                <div class="widget-tabs-list">
                  <ul class="Cases-nav nav nav-tabs">
                    <li>
                      <Link data-toggle="tab" to="/Users">
                        Users
                      </Link>
                    </li>
                    <li>
                      <Link
                        data-toggle="tab"
                        to="/User_Requests"
                        class="active show"
                      >
                        Requests
                      </Link>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <div class="Table_Search row">
                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Province</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="ProvinceId"
                      options={this.state.Provincelist}
                      val={this.state.ProvinceId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.ProvinceLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">District</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="DistrictId"
                      options={this.state.FilteredDistrictlist}
                      val={this.state.DistrictId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.DistrictLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">Tehsil</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="TehsilId"
                      options={this.state.FilteredTehsillist}
                      val={this.state.TehsilId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.TehsilLoader}
                      searchBy="name"
                      labelField="name"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container Search_InputSelectContainer col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">User Type</label>
                    <DropDown
                      multi={false}
                      dropdownRenderer={false}
                      create={false}
                      onChange={this.HandleAutoSuggestValChange}
                      Type="RoleId"
                      options={this.state.Roleslist}
                      val={this.state.RoleId}
                      addPlaceholder=""
                      disabled={false}
                      loading={this.state.RolesLoader}
                      searchBy="roleName"
                      labelField="roleName"
                      valueField="id"
                      contentRenderer={false}
                      placeholder="Select"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">User Name</label>
                    <input
                      autocomplete="off"
                      type="text"
                      class="form-control Search_InputField"
                      id="SearchName"
                      placeholder="Enter user name"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <label for="">User Phone</label>
                    <input
                      autocomplete="off"
                      pattern="[0][0-9]{10}"
                      type="number"
                      class="form-control Search_InputField"
                      id="UserPhone"
                      placeholder="Enter user phone"
                    />
                  </div>

                  <div class="formInput_Container col-lg-3 col-md-3 col-sm-12 col-xs-12">
                    <button
                      onClick={() => {
                        this.PopulateTable()
                      }}
                      style={{ position: 'relative', marginTop: 36 }}
                      id="FormSearchBtn"
                      class="btn SearchTable_Btn"
                    >
                      Search
                    </button>
                  </div>
                </div>
                {/*
                    <div class="TableTop_Buttons">
                        <span onClick={() => { $(".react-bs-table-csv-btn").click()}} class="TableExport_button"><i class="fa fa-download" aria-hidden="true"></i> Export</span>
                    </div> */}

                <Table
                  keyField="id"
                  data={this.state.data}
                  page={this.state.page}
                  sizePerPage={this.state.sizePerPage}
                  totalSize={this.state.TotalRecord}
                  onTableChange={this.handleTableChange}
                  changeSizePerPage={(size) => {
                    setTimeout(() => {
                      this.setState({
                        exportLoading: true,
                      })
                      this.ExportData(size)
                    }, 1000)
                  }}
                  isPagination={true}
                  exportAllowed={this.state.permissions.includes(
                    'request-export',
                  )}
                  columns={columns}
                  loading={this.state.loading}
                  RefreshTable={this.PopulateTable}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  componentWillMount() {
    if (this.props.UserAuthentication.AuthToken === '') {
      this.props.history.push('/Login')
    }
  }

  componentDidMount() {
    // Common.AddClassToMenueLink("MenuLink_UserRequests")
    Common.AddClassToMenueLink('MenuLink_Users')
    this.GetPageConfigData(() => {
      this.PopulateTable()
    })
    $('.Search_InputField').on('keypress', (e) => {
      if (e.which === 13) {
        this.PopulateTable()
      }
    })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_RolesPermissions,
      {},
      (resp) => {
        const modifiedPermissions = resp.data
          .filter((p) => p.permissioN_GROUP === 'Users' && p.permissioN_ALLOWED)
          .map((d) => d.permissioN_NAME)
        this.setState({ permissions: modifiedPermissions })
      },
    )
  }

  GetPageConfigData = (CallBack) => {
    this.props.ShowLoader({ Isloading: true })
    var d1 = $.Deferred()
    var d2 = $.Deferred()
    var d3 = $.Deferred()
    var d4 = $.Deferred()

    this.SelectRoles(() => {
      d1.resolve()
    })
    this.SelectProvinces(() => {
      d2.resolve()
    })
    this.SelectDistricts(() => {
      d3.resolve()
    })
    this.SelectTehsil(() => {
      d4.resolve()
    })

    $.when(d1, d2, d3, d4).done(() => {
      this.props.ShowLoader({ Isloading: false })
      CallBack()
    })
  }
  SelectRoles = (Callback) => {
    this.setState({ RolesLoader: true })
    SelectAllRoles(
      (data) => {
        var filtered = data
        if (this.props.UserAuthentication?.UserInfo?.roleId === 7) {
          filtered = data.filter(function (obj) {
            return obj.id !== 1 && obj.id !== 8
          })
        }
        this.setState({
          RolesLoader: false,
          Roleslist: filtered,
        })
        Callback()
      },
      (error) => {
        this.setState({ RolesLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectProvinces = (Callback) => {
    this.setState({ ProvinceLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Province,
      { isPaginate: false },
      (data) => {
        this.setState({
          ProvinceLoader: false,
          Provincelist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ ProvinceLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectDistricts = (Callback) => {
    this.setState({ DistrictLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_District,
      {},
      (data) => {
        this.setState({
          DistrictLoader: false,
          Districtlist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ DistrictLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  SelectTehsil = (Callback) => {
    this.setState({ TehsilLoader: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'GET',
      false,
      Common.APILinks.SelectAll_Tehsil,
      {},
      (data) => {
        this.setState({
          TehsilLoader: false,
          Tehsillist: data.data,
        })
        Callback()
      },
      (error) => {
        this.setState({ TehsilLoader: false })
        this.props.ShowAlert({ Type: 0, Msg: error })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
        Callback()
      },
    )
  }
  handleTableChange = (
    type,
    { page, sizePerPage, filters, sortField, sortOrder, cellEdit },
  ) => {
    if (type === 'sort') {
      let tempFieldorderLabel = sortField + 'sortOrder'
      let tempFieldorder =
        this.state[tempFieldorderLabel] === ''
          ? sortOrder
          : this.state[tempFieldorderLabel] === 'asc'
          ? 'desc'
          : 'asc'
      this.setState(
        {
          sortField,
          [tempFieldorderLabel]: tempFieldorder,
        },
        () => {
          this.PopulateTable()
        },
      )
      return
    }
    this.setState(
      {
        page,
        sizePerPage,
      },
      () => {
        this.PopulateTable()
      },
    )
  }
  ExportPdf = () => {
    const doc = new jsPDF()

    var Parameters = {
      UserName: $('#SearchName').val(),
      UserPhone: $('#UserPhone').val(),
      RoleId: this.state.RoleId,
      pageSize: this.state.TotalRecord,
      pageNumber: 1,
      provinceId: this.state.ProvinceId,
      districtId: this.state.DistrictId,
      tehsilId: this.state.TehsilId,
      srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
      sortField: this.state.sortField,
      sortOrder: this.state[this.state.sortField + 'sortOrder'],
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_UserRequests,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        if (resp.status) {
          doc.autoTable({
            theme: 'grid',
            body: [...resp.data],
            columns: [
              { header: 'id', dataKey: 'id' },
              { header: 'Name', dataKey: 'name' },
              { header: 'Role', dataKey: 'roleName' },
              { header: 'Province', dataKey: 'provinceName' },
              { header: 'Tehsil', dataKey: 'tehsilName' },
              { header: 'District', dataKey: 'districtName' },
            ],
          })

          doc.save('users.pdf')
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  ExportData = (size) => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true, data: [], TotalRecord: 0 })
    var Parameters = {
      UserName: $('#SearchName').val(),
      UserPhone: $('#UserPhone').val(),
      RoleId: this.state.RoleId,
      pageSize: size,
      pageNumber: 1,
      provinceId: this.state.ProvinceId,
      districtId: this.state.DistrictId,
      tehsilId: this.state.TehsilId,
      srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
      sortField: this.state.sortField,
      sortOrder: this.state[this.state.sortField + 'sortOrder'],
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_UserRequests,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        if (resp.status) {
          this.setState({
            data: resp.data,
            TotalRecord: resp.totalRecord,
            exportLoading: false,
          })
          this.PopulateTable()
          $('.react-bs-table-csv-btn').click()
        } else {
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wrong, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  PopulateTable = () => {
    $('#FormSearchBtn').prop('disabled', true)
    this.setState({ loading: true, data: [], TotalRecord: 0 })
    var Parameters = {
      UserName: $('#SearchName').val(),
      UserPhone: $('#UserPhone').val(),
      RoleId: this.state.RoleId,
      pageSize: this.state.sizePerPage,
      pageNumber: this.state.pageNumber,
      provinceId: this.state.ProvinceId,
      districtId: this.state.DistrictId,
      tehsilId: this.state.TehsilId,
      srDistrictIds: this.props.UserAuthentication?.UserInfo?.srDistrictIds,
      sortField: this.state.sortField,
      sortOrder: this.state[this.state.sortField + 'sortOrder'],
    }
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.SelectAll_UserRequests,
      Parameters,
      (resp) => {
        $('#FormSearchBtn').prop('disabled', false)
        console.log('reqeust', resp)
        this.setState({ loading: false })
        if (resp.status) {
          // if(resp.data.length > 0)
          // {
          //     var ProcessedRoles= Common.ProcessDataInArray(this.state.Roleslist,"id")
          //     var ProcessedProvince= Common.ProcessDataInArray(this.state.Provincelist,"id")
          //     var ProcessedDistrict= Common.ProcessDataInArray(this.state.Districtlist,"id")
          //     var ProcessedTehsil= Common.ProcessDataInArray(this.state.Tehsillist,"id")
          //     for (var i in resp.data)
          //     {
          //         resp.data[i].roleName = ProcessedRoles[resp.data[i].role].roleName
          //         resp.data[i].provinceName = ProcessedProvince[resp.data[i].addressProvinceId].name
          //         resp.data[i].districtName = ProcessedDistrict[resp.data[i].addressDistrictId].name
          //         resp.data[i].tehsilName = ProcessedTehsil[resp.data[i].addressTehsilId].name
          //     }
          // }
          this.setState({
            data: resp.data,
            TotalRecord: resp.totalRecord,
          })
        } else {
          this.props.ShowAlert({ Type: 0, Msg: resp.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        $('#FormSearchBtn').prop('disabled', false)
        this.setState({ loading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  onReject = (id, roleId) => {
    this.setState(
      {
        alertModalData: {
          title: 'Reject User Request',
          message: 'Are you sure you want to reject this record.',
          First_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
            this.DeleteRecord(id, roleId)
          },
          Second_Callback: () => {
            $('#Generic-modal-CloseBtn').click()
          },
          type: 1,
        },
      },
      () => {
        $('#Show_ArletModal').click()
      },
    )
  }
  RejectRecord = (id, roleId) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Reject_User,
      {
        id: id,
        roleId: roleId,
      },
      (Result) => {
        if (Result.status == true) {
          if (roleId == 4) {
            SyncConfig(
              () => {
                this.PopulateTable()
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 1, Msg: 'Rejected Successfully.' })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
              () => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                  Type: 0,
                  Msg: 'Error in sync, please reload the page',
                })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
            )
          } else {
            this.props.ShowLoader({ Isloading: false })
            this.props.ShowAlert({ Type: 1, Msg: 'Rejected Successfully' })
            setTimeout(function () {
              $('#Alertmsgbtn').click()
            }, 50)
            this.PopulateTable()
          }
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  DeleteRecord = (id, roleId) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Delete_User,
      {
        id: id,
        roleId: roleId,
      },
      (Result) => {
        if (Result.status == true) {
          if (roleId == 4) {
            SyncConfig(
              () => {
                this.PopulateTable()
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 1, Msg: 'Rejected Successfully.' })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
              () => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                  Type: 0,
                  Msg: 'Error in sync, please reload the page',
                })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
            )
          } else {
            this.props.ShowLoader({ Isloading: false })
            this.props.ShowAlert({ Type: 1, Msg: 'Rejected Successfully.' })
            setTimeout(function () {
              $('#Alertmsgbtn').click()
            }, 50)
            this.PopulateTable()
          }
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
  ApproveUser = (id, roleId) => {
    this.props.ShowLoader({ Isloading: true })
    Common.Ajax(
      this.props.UserAuthentication.AuthToken,
      'Get',
      false,
      Common.APILinks.Approve_User,
      {
        id: id,
        roleId: roleId,
      },
      (Result) => {
        if (Result.status == true) {
          if (roleId == 4) {
            SyncConfig(
              () => {
                this.PopulateTable()
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({ Type: 1, Msg: 'Approved Successfully.' })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
              () => {
                this.props.ShowLoader({ Isloading: false })
                this.props.ShowAlert({
                  Type: 0,
                  Msg: 'Error in sync, please reload the page',
                })
                setTimeout(function () {
                  $('#Alertmsgbtn').click()
                }, 50)
              },
            )
          } else {
            this.props.ShowLoader({ Isloading: false })
            this.props.ShowAlert({ Type: 1, Msg: 'Approved Successfully' })
            setTimeout(function () {
              $('#Alertmsgbtn').click()
            }, 50)
            this.PopulateTable()
          }
        } else {
          this.props.ShowLoader({ Isloading: false })
          this.props.ShowAlert({ Type: 0, Msg: Result.message })
          setTimeout(function () {
            $('#Alertmsgbtn').click()
          }, 50)
        }
      },
      (error) => {
        this.props.ShowLoader({ Isloading: false })
        this.props.ShowAlert({
          Type: 0,
          Msg: 'Something went wronge, please try again.',
        })
        setTimeout(function () {
          $('#Alertmsgbtn').click()
        }, 50)
      },
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Users_Requests)
